module.exports = __webpack_public_path__ + "img/cedb652.png";